<template>
  <div class="page-listings">
   

  
    <transition name="menu-popover" v-if="!loading">
      <div v-if="pdfPreview" class="lightbox">
        <h2 class="closeX" @click="closeLightbox()">
          <a>&#215;</a>
        </h2>
        <embed
          width="90%"
          height="100%"
          title="If you are having issues viewing this PDF, your browser security settings are set to download PDFs instead of viewing in the browser. You can also try using Chrome instead of Edge."
          :src="'data:application/pdf;base64,' + this.pdfPreview"
          style="background: #fff"
        />
      </div>
    </transition>
    <section
      v-if="loading == true"
      class="py-5 pixelsbg bs-shadow mobile-top"
      style="min-height: 260px"
    >
      <div class="container">
        <h1 class="text-white mb0 lh1">Loading GAP Order Listings....</h1>
        <br />
        <div class="hollow-dots-spinner">
          <div class="dot" style="color: #fff;"></div>
          <div class="dot" style="color: #fff;"></div>
          <div class="dot" style="color: #fff;"></div>
        </div>
        <!--
        <h2 class="text-white lh1"></h2>
        <p class="text-white lh1">Loading details</p>
        -->
      </div>
    </section>

    <section v-else class="pt-5 pb-4 pixelsbg bs-shadow mobile-top">
      <div class="container">

        <!--
         <h1 style="color: #fff">GAP Orders</h1>
        -->

              <div class="row-4" style="margin-right: -10px">
            <div class="header-bucket-wrap text-center mb10">
       
             

                <div class="top-back">
                  <h5 class="text-white top-titles mb0" id="report-step-2">
                    Yearly Total Sales
                  </h5>
                  <span class="material-icons" style="font-weight: 300; font-size: 18px;"> keyboard_arrow_down </span>

                  <h3  class="text-white">
                    {{ formatPrice(this.stats[0].TotalThisYear )}}
                  </h3>
         
                </div>

                
       
            </div>

  <div class="header-bucket-wrap text-center mb10">
              <!--
              
               <div class="top-back">
                <h5 id="report-step-2" class="text-white top-titles mb0">In Scheduling</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h3 style="color: rgba(255, 255, 255, 0.6)">Loading....</h3>
              </div>
              -->
             

                <div class="top-back">
                  <h5 class="text-white top-titles mb0" id="report-step-2">
                    AVG Order Amount
                  </h5>
                  <span class="material-icons" style="font-weight: 300; font-size: 18px;"> keyboard_arrow_down </span>

                  <h3  class="text-white">
                    {{ formatPrice(this.stats[0].AvgOrderAmount )}}
                  </h3>
         
                </div>

                
       
            </div>

              <div class="header-bucket-wrap text-center mb10">
              <!--
              
               <div class="top-back">
                <h5 id="report-step-2" class="text-white top-titles mb0">In Scheduling</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h3 style="color: rgba(255, 255, 255, 0.6)">Loading....</h3>
              </div>
              -->
             

                <div class="top-back">
                  <h5 class="text-white top-titles mb0" id="report-step-2">
                    Orders This Year
                  </h5>
                  <span class="material-icons" style="font-weight: 300; font-size: 18px;"> keyboard_arrow_down </span>

                  <h3  class="text-white">
                    {{ this.stats[0].NumberOfLines}}
                  </h3>
         
                </div>

                
       
            </div>


          </div>
     

          <div class="new-search mb20">
          <div class="input-group">
            <input 
            v-model="searchValue" 
            @keyup.enter.prevent="searchOrders"
            type="text" 
            class="form-control" 
            aria-label="Search GAP orders by order number or PO number." 
            style="padding: 14px"
            placeholder="Search GAP orders by order number or PO number."
            >
            <div class="input-group-append">
              <span v-if="searchValue?.length" @click="clearSearch" class="input-group-text new-search-btn2">
                <span class="material-icons">find_replace</span>
                {{ " " }} Clear
              </span>
              <span v-else class="input-group-text new-search-btn2">
                <span class="material-icons">find_replace</span>
                {{ " " }} Clear
              </span>

              <span @click="searchOrders" class="input-group-text new-search-btn1">
                <span class="material-icons">search</span>
                {{ " " }}Search
              </span>

            </div>
          </div>
        </div>
      


        <!--
          <div class="input-wrap">
        <input
          id="listings-step-1"
          class="top-search mt0"
          type="text"
          placeholder="Search listings by order number, PO number, or order name..."
          style="padding: 15px;"
          v-model="searchValue"
          @keyup.enter.prevent="searchQuery"
        />

        <button
            :class="[showButton ? 'clear-btn' : 'clear-hide']"
            @click="clearSearch"
            type="button"
            class="d-flex align-items-center pr-3 clear-btn"
          >
            <svg
              class="w-4 h-4 text-[#429da8] hover:text-[#1E3040]"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path
                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              ></path>
            </svg>
          </button>
        </div>
        
        -->
      

        <!--
           <div class="search-btns" style="display: flex; margin-bottom: 0">
          <div class="left-side" style="margin-right: 10px">
            <div id="listings-step-2" class="ac-select" style="margin-right: 0; margin-bottom: 10px;">
              <select
                class="form-control"
                id="exampleFormControlSelect1"
                v-model="acFilter"
              >
                <option
                  :value="null"
                  selected
                  class="all-contractors"
                  id="firstSelector"
                  style="text-transform: capitalize !important"
                >
                  Area Contractor
                </option>
                <option
                  v-for="ac in acs"
                  :key="ac.acid"
                  :value="ac.acid"
                  id="text"
                >
                  {{ " " + ac.acName + " (" + ac.acid + ")" }}
                </option>
  
              </select>
            </div>
            <div class="dates" id="dates" style="display: flex; margin-bottom: 5px;">
      
              
            
               
              
              
              <VueDatePicker v-model="startDate" 
               
                :enable-time-picker="false"
                format="MMM dd yyyy"
                placeholder="From Date"
                id="listings-step-3"
                style="padding-right: 10px;"
              ></VueDatePicker>


              <VueDatePicker v-model="endDate" 
                @update:model-value="val => console.log('endDate:', val)"
                input-class-name="dp-custom-input"
                :enable-time-picker="false"
                format="MMM dd yyyy"
                placeholder="To Date"
                wrapper-class="pickthedate"
                :typeable="true"
              ></VueDatePicker>

               

            </div>

            <div class="radios">
              <div class="control-group">
                <label class="control control--radio">
                  Entered
                  <input
                    type="radio"
                    name="radio"
                    checked="checked"
                    v-model="promised"
                    value="false"
                  />
                  <div class="control__indicator"></div>
                </label>
                <label class="control control--radio">
                  Shipping
                  <input
                    type="radio"
                    name="radio"
                    v-model="promised"
                    value="true"
                  />
                  <div class="control__indicator"></div>
                </label>
              </div>
            </div>
          </div>

          <div class="right-side" style="display: flex">
            <div
              class="search-btns"
              style="display: flex; margin-top: 0; margin-left: auto"
            >
              <button
                v-if="searchValue || startDate || endDate || acFilter"
                @click.prevent="searchQuery"
                class="search"
              >
                <span class="material-icons">search</span>
                {{ " " }} Search
              </button>
              <button v-else class="search" disabled>
                <span class="material-icons">search</span>
                {{ " " }} Search
              </button>
            </div>
          </div>
        </div>
        
        -->
     
      </div>
    </section>

    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-12 col-lg-12">
          <div>
            <div>
              <div
                v-if="loading == true"
                class="col-xs-12 col-sm-12 col-12 col-lg-12"
              >
                <div class="flex-box-wrap">
                  <div class="flex-internal">
                    <atom-spinner
                      :animation-duration="1000"
                      :size="40"
                      :color="'#575757'"
                    />
                    <p>Loading......</p>
                  </div>
                </div>
              </div>

              <div
                v-else-if="loading == false && !filteredListings.length"
                class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
              >
                <div>
                  <h2
                    style="margin: 30px 20px; color: #429da8; font-weight: 400"
                  >
                    It looks like there are no recent orders to show...
                  </h2>
                  <h3
                    style="margin: 30px 20px; color: #429da8; font-weight: 400"
                  ></h3>
                  <img src="@/assets/img/noData.svg" style="width: 100%" />
                </div>
              </div>

              <div v-else class="page" :key="searchRender">


                <listings-pagination :currPage="currPage" :totalPage="totalPage" :filteredListings="filteredListings" :setPage="setPage"/>


                <div class="listing">

                  

                 

                  <div>
                   <div class="d-flex">
                    <h2 class="mb0" data-config-id="header">GAP Order Status</h2>

                    <!--
                        <download-csv
                  class="download-csv list-btn dib center"
                  style="width: 160px; height: 40px;"
                  :data="ListingsDownload"
                  :name="'orders' + '.csv'"
                  ><i style="margin-right: 5px;" class="material-icons" aria-hidden="true" data-toogle="tooltip" title="Download this Document"> sim_card_download</i> Download CSV</download-csv
                >
                    
                    -->
                  
                   </div>
                    
                   <!--
                   
                   <p>
                      <small class="text-muted"
                        >Highlighted orders have new invoices or acknowledgments
                        that have been posted since your last login.</small
                      >
                    </p>
                   -->
                    
                  </div>

                  <div class="table-responsive">



                    
                    <table
                      class="table-striped table-bordered"
                      style="display: table"
                    >
                     <thead>
  <tr>
    <th
      v-for="c in gapColumns"
      :key="c.key"
      scope="col"
      class="table-link"
      :class="[c.cls, { 'column-active': columnSort === c.key }]"
      @click="c.date ? dateCol(c.key) : sortCol(c.key)"
    >
      <span class="th-inner">
        <span>{{ c.label }}</span>
        <i class="material-icons carrot-icon" :class="{ 'carrot-icon-active': columnSort === c.key }">filter_list</i>
      </span>
    </th>
  </tr>
</thead>

                      <tbody>
                         
                     
                   <tr
  v-for="(listing, index) in filteredListings.slice(pageStart, pageStart + countOfPage)"
  :key="listing.id"
>
  <td class="id">
    <router-link :to="'/gap-order-details/' + listing.id">{{ listing.id }}</router-link>
  </td>
  <td class="date">{{ $moment(listing.createdDate).format("MM-DD-YYYY") }}</td>
  <td class="company">{{ listing.billToName || "—" }}</td>
  <td class="po" :class="{ muted: !listing.poNumber }">{{ listing.poNumber || "—" }}</td>
  <td class="order">
    <router-link
      v-if="isValidOrderNumber(listing.orderNumber)"
      :to="`/order-details/${listing.orderNumber.trim()}`"
      :id="index === 0 ? 'EO-step-6' : ''"
    >{{ listing.orderNumber.trim() }}</router-link>
    <span v-else class="muted">—</span>
  </td>
  <td class="num">{{ formatPrice(listing.total) }}</td>
  <td class="center">
    <span v-if="listing.reviewed" class="material-icons check" title="Reviewed">check</span>
  </td>
  <td class="center">
    <span v-if="listing.inProgress" class="material-icons check" title="In progress">check</span>
  </td>


<!--
   status                        

-->
                         
                          
                          
                          
                          
                          
                          
                          



                          <!----
                          
                          
                          
                           <td>
                            <router-link
                              @click="loadTop"
                              :id="index === 0 ? 'listings-step-5' : ''"
                              :to="/order-details/ + listing.orderNo"
                              >{{ listing.orderNo }}</router-link
                            >
                          </td>
                          <td>{{ listing.customer_PO_No }}</td>
                          <td
                            v-if="listing.projName"
                            v-html="listing.projName"
                          ></td>
                          <td v-else>Unavailable</td>

                          <td>
                            {{
                              $moment(listing.entered_Date).format("MM-DD-YYYY")
                            }}
                          </td>

                          <td v-if="listing.estimated_Date">
                            {{
                              $moment(listing.estimated_Date).format(
                                "MM-DD-YYYY"
                              )
                            }}
                          </td>
                          <td v-else></td>
                          <td v-if="listing.promised_Date">
                            {{
                              $moment(listing.promised_Date).format("MM-DD-YYYY")
                            }}
                          </td>
                          <td v-else></td>

                          <td style="word-break: keep-all!important;">{{ formatPrice(listing.order_Total) }}</td>

                          <td>
                            <span
                              v-if="listing.invoicePdf.length"
                              @click="getPDF(listing.invoicePdf[0].blobPath)"
                              class="material-icons document-link"
                              >description</span
                            >
                          </td>
                          <td>
                            <span
                              v-if="listing.confirmationPDF.length"
                              @click="
                                getPDF(listing.confirmationPDF[0].blobPath)
                              "
                              class="material-icons document-link"
                              >description</span
                            >
                          </td>
                          -->
                         
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              
                <listings-pagination :currPage="currPage" :totalPage="totalPage" :filteredListings="filteredListings" :setPage="setPage"/>
     
              </div>
              <!-- page -->
            </div>
          </div>
        </div>
        <!-- end other column -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import ListingsTour from "../components/Tours/ListingsTour.vue";
import toUnicode from "../utils/toUnicode";
import { formatCurrency } from '../utils/utils';
import ListingsPagination from '@/components/Pagination/ListingsPagination.vue';
import Datepicker from 'vue3-datepicker'
import JsonCSV from "vue-json-csv";

// import { ref } from 'vue';
// import Datepicker from '@vuepic/vue-datepicker';
// import '@vuepic/vue-datepicker/dist/main.css';

// const date = ref();


const auth = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    // Authorization: "Bearer " + '9a85ad843571fe2307afb0a8f2bb252a3e88f89265aeae9c1fdcf79e14ae5df55fb1b889ae78446a003d412a74022181dd9be832bf5de34acdfda3ec403f6c97cc981b02d0f598a1e759d15a3e205f99d926b1697e12b7168e07b08d825f813bb8edcdc22d6c8b46c729916c4a36beaabe1419702987249d103428d6f4364e70'
  },
};



export default {
  name: "GAPListings",
  components: {
    AtomSpinner,
    // Avatar,
    Datepicker,
    // VueDatePicker,
    ListingsPagination,
    ListingsTour,
  },
  data() {
    return {
      attributes: [
        {
          key: "today",
          highlight: true,
          dot: "red",
          dates: {
            start: null, // From the beginning of time
            end: new Date(), // Until today
          },
        },
      ],
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      backend: import.meta.env.VITE_APP_SERVER_URL,
      searchValue: this.$route.query.search ? this.$route.query.search : "",
      search: "",
      searchValue: "",
      storedListings: [],
      searchRender: false,
      // startDate: ref(null),
      theDate: "",
      startDate: this.$route.query.start ? this.$route.query.start : null,
      endDate: this.$route.query.end ? this.$route.query.end : null,
      searchStarted: false,
      promised: false,
      acs: [],
      listings: [],
      stats:null,
      acFilter: this.$route.query.ac ? this.$route.query.ac : null,
      selectedCat: "Show All",
      searching: false,
      loading: true,
      countOfPage: 100,
      currPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      noListingFound: false,
      colSort: false,
      columnSort: "",
      pdfPreview: "",
      forumCats: [
        { id: 0, name: "Show All" },
        { id: 1, name: "Configura" },
        { id: 2, name: "Marketing" },
        { id: 3, name: "Other" },
        { id: 4, name: "Process" },
        { id: 5, name: "Product" },
        { id: 6, name: "Spacenet" },
      ],
      view: "orders",
      gapColumns: [
        { key: "id",          label: "ID" },
        { key: "createdDate", label: "Entered",     date: true },
        { key: "billToName",  label: "Company",     cls: "thirty" },
        { key: "poNumber",    label: "PO #" },
        { key: "orderNumber", label: "Order #" },
        { key: "total",       label: "Total",       cls: "num" },
        { key: "reviewed",    label: "Reviewed",    cls: "center" },
        { key: "inProgress",  label: "In Progress", cls: "center" },
      ],
    };
  },
  methods: {


    firstLoad() {
        this.loading = true;
        this.loadStats();
        this.loadOrders();
        this.searchStarted = false;
        this.$store.commit("setActivePage", "order-manage");
        // this.acListSync();

        // Return a promise for the method
        return new Promise((resolve) => {
            // Check for any filters; if filters exist, run searchQuery
            if (

                this.searchValue.length ||
                this.acFilter != null ||
                this.startDate != null ||
                this.endDate != null

            ) {

                this.searchQuery().then(() => {
                    resolve(); // Resolve after searchQuery completes
                }).catch(() => {
                    resolve(); // Ensure resolve even on error
                });

            } else {

                // Ensure listingSync returns a promise
                this.loadOrders().then(() => {
                    resolve(); // Resolve after listingSync completes
                }).catch(() => {
                    resolve(); // Ensure resolve even on error
                });

            }
        });
    },
    isValidOrderNumber(value) {
      if (!value) return false;
      const trimmed = String(value).trim();
      return trimmed !== '' && trimmed.toUpperCase() !== 'NULL';
    },
    formatPrice(amount) {
      return formatCurrency(amount);
    },

    loadStats(){
      this.loading = true;
      return axios
                .get(`${this.backend}/api/v1/gap-orders/stata`, auth)
                .then((response) => {
                    if (response.status === 401) {
                        // this.Logout();
                        this.$router.push("/");
                    } else {
                   
                        this.stats = response.data.stats;
                        // console.log("gap " + this.listings?.length)
                        // this.$store.commit("SET_GAP_COUNT", this.listings?.length);
                        // this.loading = false;
                    }
                })
                .catch((error) => {
                    // console.log(error);
                    localStorage.removeItem("SSCUSER");
                    this.$router.push("/");
                    // this.loading = false; // Ensure loading is false on error
                });
    },

    loadOrders(){
      this.loading = true;
      return axios
                .get(`${this.backend}/api/v1/gap-orders`, auth)
                .then((response) => {
                    if (response.status === 401) {
                        // this.Logout();
                        this.$router.push("/");
                    } else {
                   
                        this.listings = response.data.orders;
                        console.log("gap " + this.listings?.length)
                        this.$store.commit("SET_GAP_COUNT", this.listings?.length);
                        this.loading = false;
                    }
                })
                .catch((error) => {
                    // console.log(error);
                    localStorage.removeItem("SSCUSER");
                    this.$router.push("/");
                    this.loading = false; // Ensure loading is false on error
                });
    },

    /*
    async searchOrders(searchTerm) {
      try {
        const response = await axios.get('/api/v1/gap-orders/search', {
          params: {
            search: searchTerm.trim()   // e.g. "PO-123", "ABC456", "2025"
          }
        });

        console.log('Found orders:', response.data.orders);
        console.log('Count:', response.data.count);
        console.log('Searched for:', response.data.searchedFor);
        return response.data.orders;
      } catch (error) {

        console.error('Search failed:', error);
        if (error.response) {
          // Server responded with error (e.g. 500)
          alert(error.response.data.message || 'Search failed');
        } else {
          alert('Network error - cannot reach server');
        }
        return [];

      }
    },
    */
    
    acListSync: function () {
      this.loading = true;

      if (!this.$store.state.acList.acList.length) {
        //console.log("getting acList");
        return axios
          .get(`${this.ordermanageapi}/aclist?active=true`, auth)
          .then((response) => {
            //console.log(response);
            const data = response.data;

            /*

            const low = data.filter(function (e) {
              return e.acid < 210;
            });

            const mid = data.filter(function (e) {
              return e.acid == 80069;
            });

            const high = data.filter(function (e) {
              return e.acid > 800000 && e.acid < 800250;
            });

            const all = low.concat(high).concat(mid);
            const alph = all.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            */

            //this.acs = alph;
            const alph = data.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            this.acs = alph;
            //this.acs.sort((a, b) => (a.acName > b.acName) ? 1 : -1);
            //this.loading = false;
            this.$store.commit("UPDATE_ACLIST", this.acs);
          });
      } else {
        //console.log("vuex has length");
        this.acs = this.$store.state.acList.acList;
        this.loading = false;
      }
    },

    toUpperCase: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.toUpperCase();
      });
    },

    searchReset: function () {
      this.selectedCat = "Show All";
      this.acFilter = 0;
    },

    setPage: function (idx) {
      this.search = "";
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
      const newQuery = {
          ...this.$route.query, // Include existing query parameters
          page: idx, // Update or add the page parameter
          // Add any other parameters you want to preserve or modify here
          // For example: search: this.search, otherParam: this.otherValue
      };

      // console.log(newQuery);

      // Update the route with the new query parameters
      this.$router.push({ query: newQuery });

    },

    catSwitcher: function (catType) {
      //console.log(catType);
      let category = catType;
      //console.log(category);
      if (category !== "Show All") {
        this.selectedCat = category;
        this.search = "";
        //console.log(category);
      } else {
        this.selectedCat = "Show All";
      }
    },
    searchOrders() {
      this.loading = true;

      // Use params object instead of string concatenation → cleaner & safer
      // Also avoids manual ?search=... encoding issues
      axios
        .get('http://spacenet3api.spacesaver.com/api/v1/gap-orders/search', {
          params: {
            search: this.searchValue?.trim() || ''   // safe-guard against undefined/null
          },
          // If you still need custom headers (e.g. Authorization), keep them here
          // headers: { ...auth.headers }   // ← only if auth is an object with headers
        })
        .then((response) => {
          // Success (200–299)
          this.listings = response.data.orders || [];
          
          // Optional: store the search term or count if you want to show it
          // this.lastSearched = response.data.searchedFor;
          // this.resultCount = response.data.count;

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;

          if (error.response) {
            // Server responded with error status (400, 401, 500, etc.)
            const status = error.response.status;

            if (status === 401 || status === 403) {
              // Token expired / unauthorized
              localStorage.removeItem("SSCUSER");
              this.$router.push("/");
              return;
            }

            // Optional: show backend message
            if (error.response.data?.message) {
              this.$toast?.error?.(error.response.data.message) || alert(error.response.data.message);
            }
          } else if (error.request) {
            // No response received (network down, CORS, timeout, etc.)
            this.$toast?.error?.("Network error – cannot reach server") || alert("Network error");
          } else {
            // Something else went wrong in setup
            console.error("Axios setup error:", error.message);
          }
        });
    },


    searchQuery(event) {
        this.searchStarted = true;

        // Store current listings if search has started
        if (this.searchStarted) {
            this.storedListings = this.listings;
        }

        this.loading = true;
        this.searching = true;
        this.search = "";

        // Build the query parameters
        const queryParams = new URLSearchParams();

        // Add parameters based on their presence
        if (this.searchValue.length) {
            queryParams.append('search', toUnicode(this.searchValue.trim()));
        }
        if (this.acFilter != null) {
            queryParams.append('ac', this.acFilter);
        }
        if (this.startDate != null) {
            queryParams.append('start', this.startDate);
        }
        if (this.endDate != null) {
            queryParams.append('end', this.endDate);
        }
        if (this.promised != null) {
            queryParams.append('promised', this.promised);
        }
        if (this.currPage != null) {
            // queryParams.append('page', this.currPage);
        }

        // Add the page parameter if needed (replace `this.currPage` with your current page variable)
        /*
        if (this.currPage) {
            queryParams.append('page', this.currPage);
        }
        */

        // Push the state with the constructed URL
        history.pushState({}, "", `/listings?${queryParams.toString()}`);

        // Fetch the listings based on the search endpoint
        return axios.get(this.searchEndpointCompute, auth).then((response) => {
            this.listings = response.data;

            // console.log(response);
            this.loading = false;
            this.searching = false;
        });
    },

    clearSearch() {
      this.searchValue = "";
      this.loadOrders();
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    sortCol: function (type) {
      console.log(type);
      this.columnSort = type;
      const COLUMN = type;



        //console.log(COLUMN)
        /*
        const distantFuture = new Date(8640000000000000);
        const firstSort = type;

        let sorted = filteredListings.sort((a, b) => {
          let dateA = a[firstSort] ? new Date(a[firstSort]) : distantFuture;
          let dateB = b[firstSort] ? new Date(b[firstSort]) : distantFuture;
          return dateA.getTime() - dateB.getTime();
        });

        this.filteredListings = sorted;
        */


      if (this.colSort) {
        this.filteredListings.sort((a, b) => (a[COLUMN] > b[COLUMN] ? 1 : -1));
      } else {
        this.filteredListings.sort((a, b) => (a[COLUMN] < b[COLUMN] ? 1 : -1));
      }


      this.colSort = !this.colSort;
    },

    dateCol: function (type) {
      console.log(type);
      this.columnSort = type;
      const COLUMN = type;
      const distantFuture = new Date(8640000000000000);

      if (this.colSort) {
        this.filteredListings.sort((a, b) => {
          let dateA = a[COLUMN] ? new Date(a[COLUMN]) : distantFuture;
          let dateB = b[COLUMN] ? new Date(b[COLUMN]) : distantFuture;
          return dateA > dateB ? 1 : -1;
        });
      } else {
        this.filteredListings.sort((a, b) => {
          let dateA = a[COLUMN] ? new Date(a[COLUMN]) : distantFuture;
          let dateB = b[COLUMN] ? new Date(b[COLUMN]) : distantFuture;
          return dateA < dateB ? 1 : -1;
        });
      }
      this.colSort = !this.colSort;
    },

    loadTop() {
      window.scrollTo(0, 0);
    },

    calcProcessing: function () {
      if (this.order != null && this.loading == false) {
        let orderstate = this.order.orderStatus[0].status;
        if (
          orderstate == "In Engineering" ||
          orderstate == "In Planning" ||
          orderstate == "Planned" ||
          orderstate == "Released" ||
          orderstate == "Reserved" ||
          orderstate == "Picked" ||
          orderstate == "Partially Delivered" ||
          orderstate == "Delivered" ||
          orderstate == "Invoiced/Closed"
        ) {
          //console.log("true");
          // this.processing = true;
          return true;
        } else {
          // this.processing = false;
          //console.log("false");
          return false;
        }
      } else {
        return;
      }
    },

    calcPreProd: function () {
      if (this.order != null && this.loading == false) {
        let orderstate = this.order.orderStatus[0].status;
        if (
          orderstate === "In Planning" ||
          orderstate == "Planned" ||
          orderstate == "Released" ||
          orderstate == "Reserved" ||
          orderstate == "Picked" ||
          orderstate == "Partially Delivered" ||
          orderstate == "Delivered" ||
          orderstate == "Invoiced/Closed"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return;
      }
    },

    calcInProd: function () {
      if (this.order != null && this.loading == false) {
        let orderstate = this.order.orderStatus[0].status;
        if (
          orderstate == "Released" ||
          orderstate == "Reserved" ||
          orderstate == "Picked" ||
          orderstate == "Partially Delivered" ||
          orderstate == "Delivered" ||
          orderstate == "Invoiced/Closed"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return;
      }
    },

    calcShipped: function () {
      if (this.order != null && this.loading == false) {
        let orderstate = this.order.orderStatus[0].status;
        if (
          orderstate === "Partially Delivered" ||
          orderstate === "Delivered" ||
          orderstate === "Invoiced/Closed"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return;
      }
    },

    getPDF(link) {
      return axios
        .get(`${this.ordermanageapi}/${link}`, auth)
        .then((response) => {
          console.log(response.data);
          this.pdfPreview = response.data[0].pdfblog;
        });
    },

    showPDF(doc) {
      this.pdfPreview = doc;
    },

    closeLightbox() {
      this.pdfPreview = "";
    },

  },
  computed: {
    ListingsDownload() {
        return this.listings.map(item => ({
          orderNo: item.orderNo,
          status: item.status,
          acName: item.acName,
          estimated_Date: item.estimated_Date,
          entered_Date: item.entered_Date,
          customer_PO_No: item.customer_PO_No,
          order_Total: item.order_Total,
          projName: item.projName,
          promised_Date: item.promised_Date
        }));
    },
    activeNav() {
      return this.$store.state.activePage;
    },
    showButton() {
      if (this.searchValue.trim().length > 0 || this.acFilter || this.startDate || this.endDate || this.searchStarted) {
        // console.log('true')
        return true;
      } else {
        // console.log('false')
        return false;
      }
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    filteredListings: function () {
      //set the current page to 0
      this.currPage = 1;
      //if the search box is filled in
      if (this.search.trim() !== "") {
        return this.listings.filter((e) => {
          //filter the subject line by what is filled in the search box
          return (
            e.id.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else if (this.selectedCat !== "Show All") {
        this.search = "";
        //console.log(this.selectedCat);
        return this.listings.filter((f) => {
          return f.Type == this.selectedCat;
        });
      } else {
        return this.listings;
      }
    },

    foundNoListing: function () {
      if (this.search.length > 1 && this.filteredListings.length === 0) {
        //this.noUserFound = true;
        return true;
      }
    },

    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },

    totalPage: function () {
      return Math.ceil(this.listings.length / this.countOfPage);
    },
    listingRestore: function () {
      if (
        !this.searchValue &&
        !this.loading &&
        !this.searching &&
        this.storedListings.length >= this.listings
      ) {
        //console.log("fired off");
        this.listings = this.storedListings;
      }
      return;
    },
    searchEndpointCompute() {
      let url = `${this.ordermanageapi}/order`;
      const params = [];

      if (this.searchValue) {
        params.push(`search=${toUnicode(this.searchValue.trim())}`);
      }
      if (this.startDate) {
        params.push(`start=${this.formatDate(this.startDate)}`);
      }
      if (this.endDate) {
        params.push(`end=${this.formatDate(this.endDate)}`);
      }
      if (this.acFilter) {
        params.push(`ac=${this.acFilter}`);
      }
      if (this.promised) {
        params.push(`promised=${this.promised}`);
      }

      // Append parameters if there are any
      if (params.length) {
        url += `?${params.join('&')}`;
      }

      return url;
    }
  },
  created() {
    this.$store.commit("showNavigation");
  },

  mounted() {
    this.firstLoad().then(() => {
      // After initial load, set the page if there's a `page` query parameter
      if (this.$route.query.page) {
        this.setPage(parseInt(this.$route.query.page));
      }
      console.log(this.$tours);
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.download-csv {
  display: none;
  /*
  dib center
  */
}
@media (min-width: 992px) {
  .download-csv {
    display: block;
    margin-bottom: 10px;
  margin-left: auto;
  line-height: 1;
  display: flex;
  }
}
@media all and (min-width: 992px) {
  .flex-box-wrap {
    height: 200px;
    padding: 150px 0 125px 0;
    margin: 0;
  }
}

@media all and (max-width: 991px) {
  .flex-box-wrap {
    height: 100px;
    padding: 75px 0 50px 0;
    margin: 0;
    justify-content: center;
    align-items: center;
  }
}
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.listing {
  background-color: #fff;
  line-height: 1;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.listing-bottom {
  align-items: flex-end;
}
.listing-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.small-lh {
  line-height: 1.4em;
}

.listing {
  overflow: scroll;
}

.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03);
  /*background-color: #fff;*/
}

.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.date-area {
  margin-top: 15px;
}
.pag-wrapper {
  display: flex;
  width: 100%;
}
.pag-wrapper p {
  margin-bottom: 0;
}
.mrauto {
  margin-right: auto;
}
.search-btns {
  /*display: flex;*/
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 23px 5px;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
  margin-right: 10px;
}

.search-btns .clear {
  margin-right: 0;
  margin-left: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

.search-btns .search {
  /*margin-left: auto;*/
  margin-right: 0;
  margin-left: auto;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

.right-side {
  text-align: right;
  height: 57px;
}

@media all and (min-width: 768px) {
  .dates {
    display: flex;
    color: #757575 !important;
  }
  .left-side {
    width: 500px;
  }
}
.top-search {
  color: #757575;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
@media all and (min-width: 992px) {
  table {
    min-width: 100%;
  }
}

@media all and (max-width: 991px) {
  table {
    width: 800px !important;
    overflow: scroll;
  }
}
/*
flex-direction: column;
*/
.document-link {
  color: #429da8;
  cursor: pointer;
}
.document-link:hover {
  color: #00b4b4;
  cursor: pointer;
}
.document-link:active {
  color: #00b4b4;
  cursor: pointer;
}
/* row */
.new {
  background-color: rgba(0, 115, 219, 0.08) !important;
  /*background-color: rgba(77, 89, 103, 0.08) !important;*/
}
.radios {
  color: #fff;
}

/* radios */
.control-group {
  margin-top: 5px;
  display: inline-block;
  vertical-align: top;
  text-align: left;
}
.control {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 18px;
  margin-right: 10px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
}
.control--radio .control__indicator {
  border-radius: 50%;
}
.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc;
}
.control input:checked ~ .control__indicator {
  background: #4d5967;
}
.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #4d5967;
}
.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control__indicator:after {
  content: "";
  position: absolute;
  display: none;
}
.control input:checked ~ .control__indicator:after {
  display: block;
}
.control--checkbox .control__indicator:after {
  left: 8px;
  top: 4px;
  width: 3px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}
.control--radio .control__indicator:after {
  left: 7px;
  top: 7px;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: #fff;
}
.control--radio input:disabled ~ .control__indicator:after {
  background: #7b7b7b;
}
.new-search-btn1{
    background: #4d5967;
    color: #fff;
    border: none;
    transition: background-color 0.5s ease;
    cursor:pointer;
}
.new-search-btn1:hover{
    background:#373f49;
}
.new-search-btn2{
  background: #6a7b8e;
  color: #fff;
  border: none;
  transition: background-color 0.5s ease;
  cursor: pointer;
}
.new-search-btn2:hover{
  background: #3e4b5a;
}
.dp-custom-input {
  padding: 10px 10px 10px 10px!important;
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 14px;
  border: none;
  background: none;
}
.clear-hide {
  display: none !important;
}
.input-wrap {
  position: relative;
  display: block;
}

.dp__action_cancel {
    color: var(--dp-text-color);
    border: 1px solid var(--dp-border-color);
}

.dp__action_buttons .dp__action_select {
    background: var(--dp-primary-color);
    color: var(--dp-primary-text-color);
}
.ten{
  width: 10%!important;
}
.twenty{
  width: 20%!important;
}
table td{
  word-break: none;
}
.row-4 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex: 1;
}
.header-bucket-wrap {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
    padding-right: 10px;
}
.top-back {
    display: inline-block;
    padding: 10px;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 4px;
    transition: background 0.5s ease;
    text-decoration: none;
}
.pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.table-striped th {
  background: #4d5967;
  color: #fff;
  font-size: 12px;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 10px 10px;
  white-space: nowrap;
  vertical-align: middle;
}

.table-striped td {
  padding: 10px;
  line-height: 1.35;
  font-weight: 400 !important;
  vertical-align: middle;
}

/* Column roles */
.table-striped td.status { font-size: 13px; font-weight: 400 !important; color: #4d5967; white-space: nowrap; }
.table-striped td.order a { font-weight: 600; color: #00797d; text-decoration: none; }
.table-striped td.order a:hover { text-decoration: underline; }
.table-striped td.po { color: #4d5967; }
.table-striped td.name { color: #1f2933; }
.table-striped td.date { white-space: nowrap; color: #4d5967; }
.table-striped td.num { text-align: right; white-space: nowrap; font-weight: 400 !important; }
.table-striped td.doc { text-align: center; }
.table-striped .muted { color: #a0a6ad; }

/* Sort icons: quieter until active */
.carrot-icon { font-size: 16px; opacity: 0.45; vertical-align: middle; }
.carrot-icon-active { opacity: 1; }
.listing table { font-size: 14px; color: #2f3640; font-variant-numeric: tabular-nums; }

.th-inner { display: flex; align-items: center; justify-content: space-between; gap: 6px; }
.table-striped th.center .th-inner { justify-content: center; }
.table-striped th.num .th-inner { justify-content: flex-end; }

.table-striped td.id a { color: #4d5967; font-weight: 400; text-decoration: none; }
.table-striped td.id a:hover { text-decoration: underline; }
.table-striped td.company { color: #1f2933; }
.table-striped td.center { text-align: center; }
.check { font-size: 18px; color: #4d5967; vertical-align: middle; }
</style>
